import { Pipe, PipeTransform } from '@angular/core';
import { UnitConversionService, UnitType } from '@shared/services/unit-convertion.service';
import { UserPreferencesService } from '@shared/services/user-preferences.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'unitConvert', // Pipe name
})
export class UnitConvertPipe implements PipeTransform {

  constructor(private userPreference: UserPreferencesService) {}

  transform(
    value: number|string,
    unitType: string,
    displayUnit: boolean = false
  ): string {
    const convertedValue = this.userPreference.convertUnitByPreference(value, unitType);
    if (displayUnit) {
      const unitName = this.userPreference.getUnitNameByPreference(unitType);
      return `${convertedValue} ${unitName}`;
    }
    return `${convertedValue}`;
  }


}

